import { Component, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { LiftOrder, LiftOrderService, BasedOn } from '../../services/lift-order.service';
import { CustomerSupplierService } from '../../services/customer-supplier.service';
import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { MaterializeAction, MaterializeDirective, toast } from 'angular2-materialize';
import { ProductionOrderService } from '../../services/production-order.service';
import { Utils } from '../../util';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-read-lift-order',
  templateUrl: './read-lift-order.component.html',
  styleUrls: ['./read-lift-order.component.css']
})
export class ReadLiftOrderComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  loaded: boolean = false;
  permission: any = {};

  liftOrders:any;

  dateFilter: '15days' | 'always' = '15days';
  get days15FromToday(){
    let date = new Date();
    date.setDate(date.getDate() - 15);
    return Utils.stringDate(date);
  }
  receivedAll: boolean = false;
  odpFilter: 'without' | 'all' = 'without';

  unfilteredData: any[];
	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Número de Orden de Compra', name: 'name'},
    {title: 'Cliente', name: 'customerName'},
    {title: 'Código', name: 'prClientCode'},
    {title: 'Versión', name: 'prClientVersion'},
    {title: 'Producto', name: 'prClientName'},
    {title: 'Fecha', name: 'date'},
    {title: 'Orden de producción', name: 'productionOrderName'},
    { title: 'Acciones', className: 'center w',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
      { name: 'delete', title: '', styleIcon: 'work', action: 'onConvert',
            styleClass: 'btn-floating btn waves-effect blue darken-2', },
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
        { name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
          styleClass: 'btn-floating btn waves-effect red darken-2', }
          
      ] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
      onDelete: this.onDelete.bind(this),
      onConvert: this.onConvert.bind(this)
		}
  };

  subs = [];

  constructor(
    private service: LiftOrderService,
    private customerService: CustomerSupplierService,
    private productionOrderService: ProductionOrderService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs[0] = this.settings.getPayrollSettings('1').subscribe(setting => {
      this.itemsPerPage = setting.tableQuantity;
    })
    this.liftOrders = {};
		this.subs[1] = this.service.getLiftOrders({fromDate: this.days15FromToday, onEmpty: this.onEmpty}).subscribe(this.onSubscribe);
    this.customers = {};
    this.subs[2] = this.customerService.getCustomers().subscribe(customers => {
      this.rowsRead[0] = customers.map(customer => {
        customer.id = customer.id$;
        this.customers[customer.id] = customer;
        return customer;
      })
    });
    this.subs[3] = this.productionOrderService.getLastProductionOrder().subscribe(tempOrders => {
      if (tempOrders[0] === undefined) {
          this.productionOrderNextFolio = Utils.getNextFolio('');
      } else {
          this.productionOrderNextFolio = Utils.getNextFolio(tempOrders[0].projectFolio);
      }

      //this.productionOrderName = 'PRD' + this.productionOrderNextFolio;
    });
	}

  ngOnInit() {
  }
  ngOnDestroy() {
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    });
  }

  onSubscribe = tempLiftOrders => {
    this.unfilteredData = tempLiftOrders.map(liftOrder => {
      const {id, customerObj,basedOn=BasedOn.PrClient, prClientObj: [prClientObj]=[null], prVntaObj,quotObj,updatedAt, ...cleanLiftOrder} = liftOrder;
      this.liftOrders[liftOrder.id] = {...cleanLiftOrder}
      liftOrder.name = liftOrder.number;
      liftOrder.customerName = customerObj.name;
      liftOrder.prClientName = basedOn == BasedOn.PrClient ? prClientObj.prVntaObj.name : prVntaObj.name;
      liftOrder.prClientCode = prClientObj && prClientObj.code || '';
      liftOrder.prClientVersion = prClientObj && prClientObj.version || '';
      liftOrder.productionOrderName = liftOrder.status ? liftOrder.productionOrderObj.name : 'N.A.';
      return liftOrder;
    });
    this.filter();
    this.loaded = true;
  }
  onEmpty = () => {
    this.loaded = true;
  }
  onDateFilterChange(){
    console.log(`Changed to ${this.dateFilter}`);
    if(this.dateFilter == 'always' && !this.receivedAll){
      this.receivedAll = true;
      this.loaded = false;
      this.subs[1].unsubscribe();
      this.subs[1] = this.service.getLiftOrders({onEmpty: this.onEmpty}).subscribe(this.onSubscribe);
    }else{
      this.filter();
    }
  }
  filter(){
    console.log(`Changed to ${this.dateFilter}`);
    this.data = (this.unfilteredData || []).filter(({productionOrderName, date}) => {
      let dateCondition = this.dateFilter == 'always' || date >= this.days15FromToday;
      let odpCondition = this.odpFilter == 'all' || productionOrderName == 'N.A.';
      return dateCondition && odpCondition;
    });
    this.length = this.data.length;
    console.log(`New Length: ${this.length}`);
    this.onChangeTable(this.config);
  }

  deleteLiftOrder(sid: string) {
    this.service.deleteLiftOrder(sid);
	}

	onCellClick(data: any): any {
		this.service.windowReplace('view', data.row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.openModalRead(0);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    if(data.row.status) return toast('Un pedido convertido no puede ser editado.', 2000);
		this.service.windowReplace('edit', `${data.row.id}/${data.row.customerObj.id}`);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    if(data.row.status) return toast('Un pedido convertido no puede ser eliminado.', 2000);
		this.deleteLiftOrder(data.row.id);
	}

  //////////////////////////////////////////////////////////////////////////////////////////////CONVERT TO PRODUCTION ORDER
  modalActionsConvert = new EventEmitter<string|MaterializeAction>();
  modalParamsConvert = [{dismissible: true}];

  convert: any;

  productionOrderName: string;
  productionOrderNextFolio: number;

  onConvert({row: {
    id, prClientName, quantity, status, number, pricePerUnit, deliveryDate = '',
    prClientObj: [{longDescription='', shortDescription='', code='', version='', barCode='', prVntaObj: prVntaObj2=<any>{}, id: prClientId='', designComments='', qualityComments='', processOwnerComments='', newVersionMotive='', isLineProduct=false, ...prClientObj}]=[{}],
    prVntaObj=<any>{}, quotObj, basedOn,
    customerObj: {id: customerId},
    addressId, productionOrderObj
  }}) {
    if(status) {
      let {id} = productionOrderObj;
      localStorage.routeBack = '/liftOrder';
      return this.router.navigate([`/vw_production_order/${id}`]);
    }
    let prVntaId = prVntaObj.id || prVntaObj2.id;
    let {sections=[], generalActivities=[]} = basedOn == BasedOn.PrVnta ? prVntaObj : basedOn == BasedOn.Quot ? quotObj : prClientObj;
    this.convert = {id, prClientName, quantity, number, longDescription, shortDescription, code, version, barCode, designComments, qualityComments, processOwnerComments, newVersionMotive, sections, generalActivities, prClientId, pricePerUnit, deliveryDate, prVntaId, customerId, addressId};
    this.convert.name = `${isLineProduct ? 'PRD' : 'PNL'}${this.productionOrderNextFolio}`;
    console.log(this.convert);
    this.modalActionsConvert.emit({ action: 'modal', params: ['open'] });
  }
  continueConvert(){
    const date = new Date();
    const productionOrderJson = {
      active: 1,
      createdAt: date,
      updatedAt: date,

      employeeId: '',
      longDescription: this.convert.longDescription,
      name: this.convert.name,
      date: this.today,
      projectFolio: this.productionOrderNextFolio,
      shipId: '',
      shortDescription: this.convert.shortDescription,

      status: 'key1',
      quantity: this.convert.quantity,
      deliveryDate: this.convert.deliveryDate,
      pricePerUnit: this.convert.pricePerUnit,
      prVntaId: this.convert.prVntaId,
      prClient: { id: this.convert.prClientId, code: this.convert.code, version: this.convert.version, barCode: this.convert.barCode, designComments: this.convert.designComments, qualityComments: this.convert.qualityComments, processOwnerComments: this.convert.processOwnerComments, newVersionMotive: this.convert.newVersionMotive },
      customer: { id: this.convert.customerId, purchaseOrderNumber: this.convert.number, addressId: this.convert.addressId },

      sections: this.convert.sections,
      generalActivities: this.convert.generalActivities
    };
    let prodId = this.productionOrderService.postProductionOrder(productionOrderJson);
    
    let liftOrder = {...this.liftOrders[this.convert.id]}
    this.service.updateLiftOrder(this.convert.id,{
      ...liftOrder,
      status: 1,
      productionOrderRef: prodId,
      customerRef: liftOrder.customerRef.id,
      prClientRef: liftOrder.prClientRef && liftOrder.prClientRef.id || '',
      quotRef: liftOrder.quotRef ? liftOrder.quotRef.id : '',
      prVntaRef: liftOrder.prVntaRef && liftOrder.prVntaRef.id || ''
    });
    this.closeModalConvert();
    this.router.navigate([`/vw_production_order/${prodId}`]);
  }
  closeModalConvert() {
    this.modalActionsConvert.emit({ action: 'modal', params: ['close'] });
  }
  //////////////////////////////////////////////////////////////////////////////////////////////CONVERT TO PRODUCTION ORDER


	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA 
  modalActionsRead = new EventEmitter<string|MaterializeAction>();
  modalParamsRead = [{dismissible: true}];
  openModalRead(index: number) {
    this.currentReadIndex = index;
    this.r_data = this.rowsRead[index];
    
    this.r_config = this.r_configs[index];
  
    this.r_onChangeTable(this.r_config);
    this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
  }
  closeModalRead() {
    this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
  }
  selectRead(data: any): any{
    this.selectedIds[this.currentReadIndex] = data.row.id;
    this.continue();
  }
  continue(){
    this.closeModalRead();
    this.service.windowReplace('add', this.selectedCustomerId);
  }

  selectedIds: string [] = [];
  customers: any = {};
  get selectedCustomerId(): string { return this.selectedIds[0] }
  get readValid(){ return !!this.selectedCustomerId };
  currentReadIndex: number;
  rowsRead = [[]];
  columnsRead = [
    [//customer
      { title: 'Nombre', name: 'name', sort: 'asc' },
      { title: 'Descripción', name: 'description' },
      { title: 'Correo electrónico', name: 'email' }
    ]
  ]


  r_data:Array<any>;
  r_rows:Array<any> = [];
  r_page:number = 1;
  r_itemsPerPage:number = 5;
  r_maxSize:number = 5;
  r_numPages:number = 1;
  r_length:number = 0;

  
  r_configs:any = this.columnsRead.map(columns => ({
    paging: true,
    sorting: {columns: columns},
    filtering: {filterString: ''}
  }));
  r_config = this.r_configs[0];

  /*********** Filter, sort, and pagination */

	r_changePage(page:any, data:Array<any> = this.r_data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  r_changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.r_config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }
    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  r_changeFilter(data:any, config:any):any {
    console.log(this.columnsRead[this.currentReadIndex])
    let filteredData:Array<any> = data;
    this.columnsRead[this.currentReadIndex].forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });
    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.r_config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columnsRead[this.currentReadIndex].forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.r_config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  r_onChangeTable(config:any, page:any = {page: this.r_page, itemsPerPage: this.r_itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.r_config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.r_config.sorting, config.sorting);
    }

    let filteredData = this.r_changeFilter(this.r_data, this.r_config);
    let sortedData = this.r_changeSort(filteredData, this.r_config);
    this.r_rows = page && config.paging ? this.r_changePage(page, sortedData) : sortedData;
    this.r_length = sortedData.length;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

  get today(){
    var today = new Date();
    var dd:string = today.getDate() + '';
    var mm:string = today.getMonth()+ 1 + '';
    var yyyy = today.getFullYear();
    if(+dd<10) dd = '0'+dd;
    if(+mm<10) mm = '0'+mm;
    return yyyy + '-' + mm + '-' + dd;
  }

}
